/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Flex, Text } from '@radix-ui/themes';

import { styled, useCallback, useState } from 'fierry/react';

import Slider from 'solis/react/primitive/slider';


const Value = styled(Text)`

  min-width: 2ch;
  text-align: center;
  white-space: nowrap;

  font-variant-numeric: tabular-nums;
`;


const FormatValue = ([ value ]) =>
{
  return value;
};


const OnValueChange = (value, setLive, onValueChange) =>
{
  setLive(value);

  onValueChange?.(value);
};


const isSameValue = (lhs, rhs) =>
{
  return lhs.length === rhs.length && lhs.every((value, index) => value === rhs[index]);
};


const Component = ({ live, onValueChange, format = FormatValue, ...props }) =>
(
  <Flex align = 'center' gap = '2'>
    <Slider {...props} value = {live} onValueChange = {onValueChange} />
    {format !== null && <Value size = '2' weight = 'medium'>{format(live)}</Value>}
  </Flex>
);


export default ({ defaultValue, onValueChange, ...props }) =>
{
  const [ live, setLive ] = useState(defaultValue);
  const [ base, setBase ] = useState(defaultValue);

  // Follow defaultValue after mount - it changes when the bound arg is snapped into
  // bounds or the surrounding context switches.
  if (!isSameValue(base, defaultValue))
  {
    setBase(defaultValue);
    setLive(defaultValue);
  }

  const onChange = useCallback(OnValueChange, [ setLive, onValueChange ]);

  return <Component {...props} live = {live} onValueChange = {onChange} />;
};
